type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
};

/** Bare lowercase-i glyph, no surrounding circle — sits inside a filled status
 *  badge (see the notification toast). For the outlined circle + i, use
 *  InfoIcon. */
const InfoGlyphIcon = (props: Props) => {
  const { width = '12', height = '12', strokeColor = 'currentColor' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none">
      <path
        d="M6 2.75H6.005"
        stroke={strokeColor}
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M6 5V9.25"
        stroke={strokeColor}
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default InfoGlyphIcon;
